import React, { useState } from 'react';

import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { AdControlProvider } from '@atlassian/ad-control-toolkit';

import { PACKAGE_NAME } from '../../model/constants.tsx';
import { BacklogButtonRefresh } from './backlog-button-refresh/view.tsx';
import { useIsExperimentEligible } from './backlog-button-refresh/eligibility.tsx';
import { ELEMENT_IDS } from './constants.tsx';
import { Banner } from './backlog-button-refresh/banner.tsx';

type Props = {
	skipExposure: boolean;
	isCreateSprintButtonVisible: boolean;
};

export const useWhiteboardsTouchpoint = ({ skipExposure, isCreateSprintButtonVisible }: Props) => {
	const { flow, isVariantEligible } = useIsExperimentEligible(skipExposure);
	const [hoverPulse, setHoverPulse] = useState(false);

	const whiteboardsTouchpoint = isVariantEligible ? (
		<JSErrorBoundary id={ELEMENT_IDS.TOUCHPOINT} packageName={PACKAGE_NAME} teamName="starburst">
			<AdControlProvider>
				<ContextualAnalyticsData
					sourceName="planOnWhiteboardBacklogButton"
					sourceType={SCREEN}
					attributes={{
						growthInitiative: 'cross-flow',
					}}
				>
					<BacklogButtonRefresh flow={flow} hoverPulse={hoverPulse} />
				</ContextualAnalyticsData>
			</AdControlProvider>
		</JSErrorBoundary>
	) : null;

	const whiteboardsBanner = isVariantEligible ? (
		<JSErrorBoundary id={ELEMENT_IDS.BANNER} packageName={PACKAGE_NAME} teamName="starburst">
			<AdControlProvider>
				<ContextualAnalyticsData
					sourceName="planOnWhiteboardBacklogBanner"
					sourceType={SCREEN}
					attributes={{
						growthInitiative: 'cross-flow',
					}}
				>
					<Banner
						flow={flow}
						setHoverPulse={setHoverPulse}
						isCreateSprintButtonVisible={isCreateSprintButtonVisible}
						hoverPulse={hoverPulse}
					/>
				</ContextualAnalyticsData>
			</AdControlProvider>
		</JSErrorBoundary>
	) : null;

	return { whiteboardsTouchpoint, whiteboardsBanner };
};
